// user.actions.ts
import { createAction, props } from '@ngrx/store';
import { UserStore } from 'app/core/user/user.types';

export const loadUser = createAction('[User] Load User');
export const loadUserSuccess = createAction(
  '[User] Load User Success',
  props<{ user: UserStore }>()
);
export const loadUserFailure = createAction('[User] Load User Failure', props<{ error: any }>());
export const updateUser = createAction('[User] Update User', props<{ user: UserStore }>());
export const setConnectedUser = createAction(
  '[User] Set Connected User',
  props<{ user: UserStore }>()
);
